import React, { useState, useContext,useEffect } from "react";
import './user-training.css'
import Button from 'react-bootstrap/Button';
import DemoQuestions from "../demoQuestions";
import Spinner from "../spinner/spinner";
import { UserContext } from '../../UserContext';
import AnswerSummary from "./answer-summary/answer-summary";
import Modal from 'react-bootstrap/Modal';
import translations from "../../translations";
import {LanguageContext} from "../../languageContext";
import {useNavigate} from "react-router-dom";
import { useToast } from "../../ToastContext";
import api from "../../api";

function CustomModal(props) {
    return (
        <Modal
            show={props.show} onHide={props.onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <img className="cross-close-btn" src="./cross.svg" alt="close-btn" onClick={props.onHide}/>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.translate("Are you sure you want to exit?")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    {props.translate("You are about to exit the training session. Any questions attempted till now, will be lost!")}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <button className="red-white-btn" onClick={props.onExit}>{props.translate("Exit")}</button>
                {/*<button className="red-white-btn" onClick={props.onSaveExit}>{props.translate("Save and Exit")}</button>*/}
            </Modal.Footer>
        </Modal>
    );
}
function ExplanationModal(props) {
    const { user } = useContext(UserContext);
    const [openIndex, setOpenIndex] = useState(0);
    const SERVER_URL = process.env.NODE_ENV === "development"
        ? "http://localhost:3000/api/v1/"
        : "/api/v1/";
    const [translatedData,setTranslatedData] = useState(null);
    const  handleTranslate = async() =>{
        try{
            let body = {
                explanations: props.body.explanations,
                language: user.nativeLanguage?user.nativeLanguage:"en"
            }
            const response = await api.post(`questions/translate`,body);
            setTranslatedData(response.data);
        }catch(e){

        }finally {

        }
    }

    const toggleAccordion = (index) => {
        setOpenIndex((prevIndex) => (prevIndex === index ? -1 : index)); // Collapse if same, otherwise open new
    };

    const handleClose = () => {
        setTranslatedData(null);
        props.onHide();
    };

    return (
        <Modal
            show={props.show} onHide={props.onHide}
            size="lg"
            className="customExplanationModal"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
                <div className="headerExplanation">
            <Modal.Header>
                <img className="cross-close-btn" src="./cross.svg" alt="close-btn" onClick={()=>{handleClose()}}/>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.translate("Explanation")}
                </Modal.Title>
            </Modal.Header>
                </div>
            <Modal.Body>
                <div className="explanationCorrectResponse">{props.translate("Correct Answer")}: {props.translate("Option")} {String.fromCharCode(65 + props.body.correctOption)}</div>
                <div>
                    <span className="explanationCorrectResponse">{props.translate("Reason")}</span>
                    {translatedData &&
                        translatedData.map((explanation, index) => (
                            <div key={index} className="accordion-item">
                                <div
                                    className="accordion-header"
                                    onClick={() => toggleAccordion(index)}
                                    style={{ cursor: "pointer", fontWeight: "bold",fontSize: "14px"}}
                                >
                                    <span className="circle">{String.fromCharCode(65 + index)}</span>
                                    Explanation {index + 1}
                                </div>
                                {openIndex === index && (
                                    <div className="accordion-content">
                                        <p
                                            className="explanation"
                                            dangerouslySetInnerHTML={{__html: explanation.translatedText}}
                                        ></p>
                                    </div>
                                )}
                            </div>
                    ))}
                    {props.body.explanations &&
                        !translatedData &&
                        props.body.explanations.map((explanation, index) => (
                            <div key={index} className={index === props.body.correctOption? "accordion-item correct-explanation":"accordion-item"}>
                                <div
                                    className="accordion-header"
                                    onClick={() => toggleAccordion(index + (translatedData ? translatedData.length : 0))}
                                    style={{ cursor: "pointer", fontWeight: "bold",fontSize: "14px" }}
                                >
                                    <span className="circle">{String.fromCharCode(65 + index)}</span>
                                    Explanation {index + 1}
                                </div>
                                {openIndex === index + (translatedData ? translatedData.length : 0) && (
                                    <div className="accordion-content">
                                        <p
                                            className="explanation"
                                            dangerouslySetInnerHTML={{__html: explanation.displayText}}
                                        ></p>
                                    </div>
                                )}
                            </div>
                    ))}
                </div>
            </Modal.Body>
            <Modal.Footer>
                {!translatedData && <button className="white-red-btn" onClick={() => {
                    handleTranslate()
                }}>Translate</button>}

            </Modal.Footer>
        </Modal>
    );
}

const Training = () => {
    const initialTime = 80 * 60;
    const [startTraining, setStartTraining] = useState(false);
    const [demoQuestionCount, setDemoQuestionCount] = useState(0);
    const [responseSubmitted, setResponseSubmitted] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState({});
    const [selectedOption, setSelectedOption] = useState(null);
    const [isResponseCorrect, setIsResponseCorrect] = useState(null);
    const [loading, setLoading] = useState(false);
    const [questionCount, setQuestionCount] = useState(0);
    const { user,setUser } = useContext(UserContext);
    const {setIsTraining } = useContext(UserContext);
    const [exitModalShow, setExitModalShow] = React.useState(false);
    const [explanationModalShow, setExplanationModalShow] = React.useState(false);
    const [trainingSessionId, setTrainingSessionId] = React.useState(null);
    const [trainingResponseSummary, setTrainingResponseSummary] = React.useState([]);
    const [explanationData, setExplanationData] = React.useState({});
    const [langOpt, setLangOpt] = useState(sessionStorage.getItem('langOpt') || 'Japanese');
    const SERVER_URL = process.env.NODE_ENV === "development" ? "http://localhost:3000/api/v1/" : "/api/v1/";
    const { language } = useContext(LanguageContext);
    const navigate = useNavigate();
    const { addToast } = useToast();
    const [timeLeft, setTimeLeft] = useState(initialTime);
    const [isRunning, setIsRunning] = useState(false);

    useEffect(() => {
        let timer;
        if (isRunning && timeLeft > 0) {
            timer = setInterval(() => {
                setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
            }, 1000);
        } else if (timeLeft === 0) {
            clearInterval(timer);
            handleTimerEnd();
        }
        return () => clearInterval(timer);
    }, [isRunning, timeLeft]);


    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')} min : ${secs.toString().padStart(2, '0')} sec`;
    };

    const handleTimerEnd = () => {
        alert(translate('Session time is Up. The result will be considered from all the questions attempted out of 40 questions. please confirm OK'));  // Replace with desired function
        setIsRunning(false);
        closeTrainingModal('Time is up!');
    };

    const handleStart = () => setIsRunning(true);
    const handlePause = () => setIsRunning(false);
    const handleReset = () => {
        setIsRunning(false);
        setTimeLeft(initialTime);
    };


    const closeTrainingModal = (text) =>{
        if(questionCount === 1 && !responseSubmitted){
            handleStartTraining();
        }else if(!user?.demoCompleted || demoQuestionCount !== -1) {
            handleStartTraining();
        }else if(text === 'Time is up!'){
            if(questionCount === 1 && !responseSubmitted){
            handleStartTraining();
            }else{
            saveProgressExit();
            handleReset();
            }
        }else{
        setExitModalShow(true)
        }
    }
    const saveProgressExit = () =>{
        handleComplete();
    }
    const exitTraining = () =>{
        setExitModalShow(false);
        handleReset();
        handleStartTraining();
    }
    const exitExplanation = () =>{
        setExplanationModalShow(false);
    }

    const backToDashboard = () =>{
        navigate(`/dashboard`);
    }
    useEffect(()=> {
        setLangOpt(language);
    },[language])

    const translate = (text) => {
        if (text) {
            return langOpt === 'Japanese' ? translations[text] : text;
        } else {
            return text
        }
    };

    const handleStartTraining = async()=>{
        if(!startTraining){
            await createSession(!user?.demoCompleted);
            if(!user?.demoCompleted){
            setDemoQuestionCount(1);
            setCurrentQuestion(DemoQuestions[0]);
            }else{
            await fetchQuestion();
            handleReset();
            handleStart();
            }
        }else{
            setDemoQuestionCount(0);
            setSelectedOption(null);
            setResponseSubmitted(false);
            setQuestionCount(0);
            setIsResponseCorrect(false)
            setCurrentQuestion({})
            setTrainingResponseSummary([]);
        }
        setStartTraining(!startTraining);
        setIsTraining(!startTraining);
    }
    const fetchQuestion = async () => {
        try {
            if(!user.userEmail) return addToast(translate("Something went wrong"),"error")
            setLoading(true);
            const body = {
                "userEmail":user.userEmail,
            }
            const response = await api.post(`questions/get_question`,body);
            setCurrentQuestion(response.data);
            setQuestionCount(questionCount+1);
            console.log(response.data);
        } catch (error) {
            addToast(translate("Error occurred in fetching question"),"error")
            setStartTraining(false);
            console.error("Error fetching question:", error);
        }finally {
            setLoading(false); // Stop loading
            setDemoQuestionCount(-1);
        }
    };

    const submitResponse = async () => {
        try {
            // setLoading(true);
            const body ={
                "userEmail": user.userEmail,
                "id": currentQuestion.id,
                "optionId": selectedOption.id
            }
            setIsResponseCorrect(selectedOption.isCorrect);
            setResponseSubmitted(true);
            const response = await api.post(`questions/sumitResponse`,body);
            await createUserResponseHistory(selectedOption.isCorrect);
            setTrainingResponseSummary((prevSummary) => {
                const updatedSummary = [...prevSummary];
                    updatedSummary.push({
                        question_id: currentQuestion.id,
                        userResponse: selectedOption.isCorrect ? "correct" : "incorrect",
                    });
                return updatedSummary;
            });
        } catch (error) {
            console.error("Error fetching question:", error);
        }finally {
            // setLoading(false); // Stop loading
            setDemoQuestionCount(-1);
        }
    };

    const createUserResponseHistory = async (isCorrectResponse ) => {
        try{
            let userResponse
            currentQuestion.options.map((option, index) => {
                if(selectedOption === option){
                    userResponse = String.fromCharCode(65 + index);
                }
            })
            const body ={
                "trainingSessionId": trainingSessionId,
                "questionId": currentQuestion.id,
                "userResponse": userResponse,
                "isCorrect": isCorrectResponse,
            }
            const createUserHistory = await api.post(`history`,body);
        }catch(error){
            console.log(error)
        }
    }

    const createSession = async (isDemo) => {
        try {
            if(!user.userEmail) return addToast(translate("Something went wrong"),"error")
            setLoading(true);
            const body ={
                "userEmail": user.userEmail
            }
            const response = await api.post(`training/sessions`,body);
            setTrainingSessionId(response.data.data.id);
            if(isDemo){
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching question:", error);
        }
    };

    const postDemoQuestionData = async () => {
        try {
            if(!user.userEmail) return addToast(translate("userEmail not found"),"error")
            const response = await api.patch(`user/demo-status`, {
                userEmail: user.userEmail,
                demoCompleted: true
            });
            handleStart();
            // Store response in context and sessionStorage
        } catch (err) {
            console.error('Error:', err);
        } finally {
            setUser((prevUser) => ({
                ...prevUser,
                demoCompleted: true,
            }));
        }
    };

    const handleOptionChange = (option) => {
        setSelectedOption(option);  // Update selected option
    };

    const handleNext = (e) => {
        setSelectedOption(null);
        setIsResponseCorrect(null);
        setResponseSubmitted(false);
        const isDemo = /Demo/i.test(currentQuestion.id);
        if(isDemo && demoQuestionCount <2 && demoQuestionCount >= 0){
            setDemoQuestionCount(2);
            setCurrentQuestion(DemoQuestions[1]);
        }else{
            if(!user?.demoCompleted){
                postDemoQuestionData()
                fetchQuestion()
            }else{
                fetchQuestion()
            }
        }
    }

    const handleComplete = async() =>{
    try{
        setLoading(true);
        let totalCount = 0; // Total number of responses
        let correctCount = 0; // Number of correct responses

        // Assuming trainingResponseSummary is globally accessible or passed to this function
        trainingResponseSummary.forEach((response) => {
            totalCount++; // Increment for each response
            if (response.userResponse === "correct") { // Check if the response is correct
                correctCount++;
            }
        });
        await updateSession(correctCount,totalCount);
    }catch(error){
        console.log(error);
    }finally {
        setLoading(false);
        await handleStartTraining();
        setExitModalShow(false);
    }
    }

    const handleExplanation = () =>{
        const correctIndex = currentQuestion.options.findIndex(option => option.isCorrect);
        let data = {
            explanations:currentQuestion.explanations,
            correctOption:correctIndex
        }
        setExplanationData(data);
        setExplanationModalShow(true);
        handlePause();
    }

    const updateSession = async (correctCount,totalCount) => {
        let body = {
            "sessionId":trainingSessionId,
            "correctCount":correctCount,
            "totalCount":totalCount
        }
        const response =  await api.put(`training/sessions`, body)

    }

    const handleSubmit = (e) => {
        if(!selectedOption){
            addToast(translate("Please select an option") ,"warning");
            return;
        }
        const isDemo = /Demo/i.test(currentQuestion.id);
        if(isDemo){
            setIsResponseCorrect(selectedOption.isCorrect);
            setResponseSubmitted(true);
        }else{
            submitResponse();
        }
    }
    return (
        <>
            {loading && <Spinner />}
            {!startTraining && <div className="custom-container">
                <div className="instruction-container" style={{'position':'relative'}}>
                    <img className="back-to-dashboard" src="./cross.svg" alt="close-btn" onClick={backToDashboard} />
                    <h4 className="demo-container-header">{translate("Welcome")} {user?.firstName?user.firstName:""}</h4>
                    <div className="demo-container-content">
                        {!user?.demoCompleted &&
                        <>
                        <p>{translate("Before starting your main practice session,we’ll begin with 2 demo questions. These questions will help you to get familiar with the format and flow of the test.Once you completed the demo, you will move on to the full set of 40 practice questions.")} </p>
                        <p>{translate("Good Luck !")} </p>
                        </>
                        }
                        {user?.demoCompleted &&
                            <>
                                <p>{translate(`You’re ready to begin your training session. Once you click 'Start', you’ll dive straight into the full set of 40 practice questions.This will help you get into the flow and focus on mastering the material.`)}</p>
                                <p>{translate("Good Luck !")}</p>
                            </>
                        }
                    </div>
                    <div style={{display:"flex",width:"100%"}}>
                    <button className="red-white-btn" style={{marginLeft:"auto"}} onClick={handleStartTraining}>{translate("Start")}
                    </button>
                    </div>
                </div>
            </div>}
            {window.innerWidth > 580 ?(
                <>
                    {startTraining && <div className="training-container">
                        <div className="double-container">
                            {(demoQuestionCount>0 && demoQuestionCount<=2) && <div className="demo-container">
                                <h4 className="demo-container-header">{translate("Welcome")} {user?.firstName?user?.firstName:""}</h4>
                                <div className="demo-container-content">
                                    <p>{translate("Before starting your main practice session,we’ll begin with 2 demo questions. These questions will help you to get familiar with the format and flow of the test.Once you completed the demo, you will move on to the full set of 40 practice questions.")} </p>
                                    <p>{translate("Good Luck !")}</p>
                                </div>
                            </div>}
                            <div className="question-container">
                                <img className="cross-close-btn" src="./cross.svg" alt="close-btn" onClick={closeTrainingModal}/>
                                {(demoQuestionCount>0 && demoQuestionCount<=2) &&  <h4>Demo Question {demoQuestionCount}/2</h4>}
                                {(demoQuestionCount === -1) &&  <h4>{translate("Question")} {questionCount}/40</h4>}
                                <div className="question">
                                    {/*{currentQuestion.question && (<FuriganaConverter kanji={currentQuestion.question} />)}*/}
                                    {currentQuestion.displayQuestion && (
                                        <div dangerouslySetInnerHTML={{__html: currentQuestion.displayQuestion}}>
                                        </div>)}
                                    <div className="question-images">
                                        {currentQuestion.imageUrl && (
                                            <img src={`data:image/png;base64,${currentQuestion.imageUrl}`} alt="question-image"/>
                                        )}
                                        {currentQuestion.imageUrl2 && (
                                            <img src={`data:image/png;base64,${currentQuestion.imageUrl2}`} alt="question-image"/>
                                        )}
                                    </div>
                                </div>
                                <div className="options">
                                    {!responseSubmitted && <ul>
                                        {currentQuestion.options && currentQuestion.options.map((option, index) => (
                                            <li key={index}
                                                className={selectedOption === option ? "selectedOption" : ""}
                                                onClick={() => handleOptionChange(option)}>
                                                <div>
                                                    <span className="circle">{String.fromCharCode(65 + index)}</span>
                                                </div>
                                                <div dangerouslySetInnerHTML={{__html: option.displayText}}></div>
                                            </li>
                                        ))}
                                    </ul>}
                                    {responseSubmitted && <ul>
                                        {currentQuestion.options && currentQuestion.options.map((option, index) => (
                                            <li key={index} className={selectedOption === option ? isResponseCorrect ? "is-correct-response":"is-incorrect-response": option.isCorrect?"is-correct-response":""}>
                                                <span className="circle">{String.fromCharCode(65 + index)}</span>
                                                <div dangerouslySetInnerHTML={{__html: option.displayText}}></div>
                                            </li>
                                        ))}
                                    </ul>}
                                </div>
                                <div className="actions">
                                    <div className="right-side-btn">
                                        {!responseSubmitted && <Button className="custom-primary-btn" onClick={handleSubmit}>{translate("Submit")}</Button>}
                                        {responseSubmitted && <Button className="custom-primary-btn" onClick={handleExplanation}>{translate("Explanation")}</Button>}
                                        {(responseSubmitted && questionCount !== 40) && <Button className="custom-primary-btn" onClick={handleNext}>{translate("Next")}</Button>}
                                        {(responseSubmitted && questionCount === 40) && <Button className="custom-primary-btn" onClick={handleComplete}>{translate("Complete")}</Button>}
                                    </div>
                                </div>
                            </div>
                            <div className="timerSummary">
                                {(demoQuestionCount === -1) &&
                                    <>
                                        <div className="timer-container">
                                            <span>{translate("Session Time")}</span>
                                            <span className={`timer-count ${timeLeft <= 120 ? "red-text timer-count" : "timer-count"}`} ><img src="./Timer.svg" alt="timer"/>{formatTime(timeLeft)}</span>
                                        </div>
                                    </>
                                }
                                {(demoQuestionCount === -1) &&
                                    <AnswerSummary translate={translate} answerSummary={trainingResponseSummary}/>
                                }
                            </div>
                        </div>
                    </div>
                    }
                </>
            ):(
                <>
                    {startTraining && <div className="training-container">
                        <div className="double-container">
                            {(demoQuestionCount > 0 && demoQuestionCount <= 2) && <div className="demo-container">
                                <h4 className="demo-container-header">{translate("Welcome")} {user?.firstName ? user?.firstName : ""}</h4>
                                <div className="demo-container-content">
                                    <p>{translate("Before starting your main practice session,we’ll begin with 2 demo questions. These questions will help you to get familiar with the format and flow of the test.Once you completed the demo, you will move on to the full set of 40 practice questions.")} </p>
                                    <p>{translate("Good Luck !")}</p>
                                </div>
                            </div>}
                            <div className="timerSummary">
                                {(demoQuestionCount === -1) &&
                                    <>
                                        <div className="timer-container">
                                            <span>{translate("Session Time")}</span>
                                            <span
                                                className={`timer-count ${timeLeft <= 120 ? "red-text timer-count" : "timer-count"}`}><img
                                                src="./Timer.svg" alt="timer"/>{formatTime(timeLeft)}</span>
                                        </div>
                                    </>
                                }
                                {(demoQuestionCount === -1) &&
                                    <AnswerSummary translate={translate} answerSummary={trainingResponseSummary}/>
                                }
                            </div>
                            <div className="question-container">
                                <img className="cross-close-btn" src="./cross.svg" alt="close-btn"
                                     onClick={closeTrainingModal}/>
                                {(demoQuestionCount > 0 && demoQuestionCount <= 2) &&
                                    <h4>Demo Question {demoQuestionCount}/2</h4>}
                                {(demoQuestionCount === -1) && <h4>{translate("Question")} {questionCount}/40</h4>}
                                <div className="question">
                                    {/*{currentQuestion.question && (<FuriganaConverter kanji={currentQuestion.question} />)}*/}
                                    {currentQuestion.displayQuestion && (<div
                                        dangerouslySetInnerHTML={{__html: currentQuestion.displayQuestion}}></div>)}
                                    <div className="question-images">
                                        {currentQuestion.imageUrl && (
                                            <img src={`data:image/png;base64,${currentQuestion.imageUrl}`} alt="question-image"/>
                                        )}
                                        {currentQuestion.imageUrl2 && (
                                            <img src={`data:image/png;base64,${currentQuestion.imageUrl2}`} alt="question-image"/>
                                        )}
                                    </div>
                                </div>
                                <div className="options">
                                    {!responseSubmitted && <ul>
                                        {currentQuestion.options && currentQuestion.options.map((option, index) => (
                                            <li key={index}
                                                className={selectedOption === option ? "selectedOption" : ""}
                                                onClick={() => handleOptionChange(option)}>
                                                <div>
                                                    <span className="circle">{String.fromCharCode(65 + index)}</span>
                                                </div>
                                                <div dangerouslySetInnerHTML={{__html: option.displayText}}></div>
                                            </li>
                                        ))}
                                    </ul>}
                                    {responseSubmitted && <ul>
                                        {currentQuestion.options && currentQuestion.options.map((option, index) => (
                                            <li key={index}
                                                className={selectedOption === option ? isResponseCorrect ? "is-correct-response" : "is-incorrect-response" : option.isCorrect ? "is-correct-response" : ""}>
                                                <span className="circle">{String.fromCharCode(65 + index)}</span>
                                                <div dangerouslySetInnerHTML={{__html: option.displayText}}></div>
                                            </li>
                                        ))}
                                    </ul>}
                                </div>
                                <div className="actions">
                                    <div className="right-side-btn">
                                        {!responseSubmitted && <Button className="custom-primary-btn"
                                                                       onClick={handleSubmit}>{translate("Submit")}</Button>}
                                        {responseSubmitted && <Button className="custom-primary-btn"
                                                                      onClick={handleExplanation}>{translate("Explanation")}</Button>}
                                        {(responseSubmitted && questionCount !== 40) &&
                                            <Button className="custom-primary-btn"
                                                    onClick={handleNext}>{translate("Next")}</Button>}
                                        {(responseSubmitted && questionCount === 40) &&
                                            <Button className="custom-primary-btn"
                                                    onClick={handleComplete}>{translate("Complete")}</Button>}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    }
                </>
            )}
            <CustomModal show={exitModalShow}
                         onSaveExit={saveProgressExit}
                         onExit={exitTraining}
                         translate={translate}
                         onHide={() => {
                             setExitModalShow(false)
                         }}
            />
            <ExplanationModal show={explanationModalShow}
                              onSaveExit={saveProgressExit}
                              body={explanationData}
                              translate={translate}
                              onHide={() => {
                                  setExplanationModalShow(false);
                                  handleStart();
                              }}
            />
        </>
    )
}

export default Training